module.exports = __webpack_public_path__ + "assets/modal-lottery-question-bg-9a0fd358.png";